import React, { useEffect, useState } from 'react';
import {
  Demanda,
  ExportarDemandaAndamento,
  getAllDemandantes,
  getAllRequisitantes,
  getDemandasDemandante,
  getDemandasPreSuprimentosAndamento,
} from '@app/api/demanda';
import {
  Button,
  FilterWidget,
  FormRangePicker,
  Loading,
  MasterDetailForm,
  OptionProps,
  useRouter,
  Widget,
} from '@digital/ui';
import GridDemandas from './GridDemandas';
import { Tooltip } from 'antd';
import { dateFormat } from '@app/helpers/dateTimeFormats';
import { FormSelectFilter } from '@app/components/FormSelectFilter';



const DemandasAndamento = (props: any) => {
  const { history } = useRouter();
  const [dados, setDados] = useState<Demanda[]>([]);
  const [update, setUpdate] = useState(false);
  const [periodoInicio, setPeriodoInicio] = useState(null);
  const [periodoFim, setPeriodoFim] = useState(null);
  const { usuarioPreSuprimentosOuAdmContratos } = props;

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [totalItens, setTotalItens] = useState(0);

  // guarda os filtros de coluna e a ordenação da grade para o export sair igual à tela
  const [filtrosGrade, setFiltrosGrade] = useState<{
    filters?: Record<string, (string | number)[] | null>;
    sorter?: any;
  }>({});

  // período efetivamente pesquisado; o do formulário só vale depois do Pesquisar
  const [periodoPesquisado, setPeriodoPesquisado] = useState<{ inicio: any; fim: any }>({
    inicio: null,
    fim: null,
  });

  const onUpdate = () => {
    setUpdate(!update);
  };

  const [listDemandantes, setDemandantes] = useState<OptionProps[]>([]);
  useEffect(() => {
    getAllDemandantes().then(data => {
      if (data) {
        setDemandantes(data);
      }
    });

  }, []);

  const [requisitantes, setRequisitantes] = useState<OptionProps[]>([]);
  useEffect(() => {
    getAllRequisitantes().then(data => {
      if (data) {
        setRequisitantes(data);
      }
    });

  }, []);

   const filtroBase = {
     PreSuprimentos: usuarioPreSuprimentosOuAdmContratos,
     ConcluidoCancelado: false,
     PeriodoInicio: periodoInicio,
     PeriodoFim: periodoFim,
   };

   const listarDemandas = (
     pagination: { current?: number; pageSize?: number } = { },
     filters?: Record<string, (string | number)[] | null>,
     sorter?: any,
   ) => {
     const { current = 1, pageSize = 10 } = pagination;

     setFiltrosGrade({ filters, sorter });
     setPeriodoPesquisado({ inicio: periodoInicio, fim: periodoFim });

     getDemandasDemandante(filtroBase, current, pageSize, filters, sorter).then(data => {
       if (data) {
        setDados(data.items);
        setPageSize(data.pageSize);
        setTotalPage(data.totalPages);
        setTotalItens(data.totalItems);
       }
     });
   };

  useEffect(() => {
    // mantém os filtros de coluna e a ordenação que a grade já está exibindo
    listarDemandas({}, filtrosGrade.filters, filtrosGrade.sorter);
  }, [update, usuarioPreSuprimentosOuAdmContratos]);


  const [exportando, setExportando] = useState(false);

  const handleExportar = async () => {
    try {
      setExportando(true);
      await ExportarDemandaAndamento(
        { ...filtroBase, PeriodoInicio: periodoPesquisado.inicio, PeriodoFim: periodoPesquisado.fim },
        filtrosGrade.filters,
        filtrosGrade.sorter,
      );
    } finally {
      setExportando(false);
    }
  };

  return (
    <>
      <FilterWidget
        title="Filtro"
        key="filterWidget"
        actions={[
          <Button type="primary" key="filterBtn" onClick={() => onUpdate()}>
            Pesquisar
          </Button>,
        ]}>
        <MasterDetailForm>
          <FormRangePicker
            value={[periodoInicio, periodoFim]}
            startName="dataInicio"
            endName="dataFinal"
            format={dateFormat}
            label="Período"
            span={4}
            onChange={dates => {
              setPeriodoInicio(dates[0]);
              setPeriodoFim(dates[1]);
            }}
          />
        </MasterDetailForm>
      </FilterWidget>
      <Widget
        title="Em Andamento"
        actions={[
          <React.Fragment key="acoesAndamento">
            <Button
              id="mrn-btn-criar-nova-demanda"
              title="criar nova demanda"
              type="primary"
              onClick={() => {
                history.push('/demanda/questionario/new');
              }}
            />
            <Tooltip title="Exportar demandas">
              <Button
                id="mrn-btn-exportar-demanda"
                type="link"
                icon="files-xls"
                onClick={handleExportar}
                style={{ marginRight: '8px' }}
                loading={exportando}
              />
            </Tooltip>
          </React.Fragment>,
        ]}>
        <GridDemandas dados={dados}

           ///listarDemandas={listarDemandas}
                      //onUpdate={onUpdate}
                      currentPage={currentPage}
                      pageSize={pageSize}
                      totalPage={totalPage}
                      totalItens={totalItens}
                      fetchData={listarDemandas}
                      demandantes={listDemandantes}
                      requisitantes={requisitantes}
                      />
      </Widget>
    </>
  );
};
export default DemandasAndamento;
